/** Growth as the services give it: hg-order's promo codes, hg-notify's campaigns and messages. */
import type { components as Auth } from "@/shared/api/auth.schema";
import type { components as Notify } from "@/shared/api/notify.schema";
import type { components as Order } from "@/shared/api/order.schema";

type OrderSchemas = Order["schemas"];
type NotifySchemas = Notify["schemas"];
type AuthSchemas = Auth["schemas"];

/** A referral partner as hg-auth shows them: the account, and since when it holds the role. */
export type ReferralPartner = AuthSchemas["ReferralPartnerResponse"];
export type PartnerInput = AuthSchemas["CreateReferralPartnerRequest"];
export type PartnerMade = AuthSchemas["ReferralPartnerCreatedResponse"];
export type PartnerLanguage = AuthSchemas["Language"];
/** The languages an account may have: its SMS and notifications come in it. */
export const PARTNER_LANGUAGES = [
  "uz",
  "uz-Cyrl",
  "kaa",
  "ru",
  "en",
] as const satisfies readonly PartnerLanguage[];
/** What hg-order's search found: here, a client. */
export type SearchHit = OrderSchemas["SearchHitResponse"];

export type PromoCode = OrderSchemas["PromoCodeAdminResponse"];
export type PromoInput = OrderSchemas["CreatePromoCodeRequest"];
export type PromoChange = OrderSchemas["UpdatePromoCodeRequest"];
export type Redemption = OrderSchemas["RedemptionResponse"];
export type FundedBy = OrderSchemas["FundedBy"];

export const FUNDERS = ["platform", "partner"] as const satisfies readonly FundedBy[];

export type Campaign = NotifySchemas["AdminCampaignResponse"];
export type CampaignAction = NotifySchemas["CampaignAction"];
export type CampaignChange = NotifySchemas["UpdateCampaignRequest"];
export type LocalizedText = NotifySchemas["LocalizedText"];
export type CampaignAudience = NotifySchemas["CampaignAudienceResponse"];
export type CampaignStatus = NotifySchemas["CampaignStatus"];
export type CampaignKind = NotifySchemas["CampaignKind"];
export type Side = NotifySchemas["Side"];
export type SmsMessage = NotifySchemas["SmsMessageResponse"];
export type SentMessage = NotifySchemas["AdminNotificationResponse"];
export type Delivery = NotifySchemas["DeliveryResponse"];
export type DeliveryStatus = NotifySchemas["DeliveryStatus"];

export const CAMPAIGN_STATUSES = [
  "draft",
  "scheduled",
  "sending",
  "sent",
  "cancelled",
] as const satisfies readonly CampaignStatus[];
export const CAMPAIGN_KINDS = [
  "announcement",
  "news",
  "story",
] as const satisfies readonly CampaignKind[];
export const SIDES = ["client", "specialist"] as const satisfies readonly Side[];
export const DELIVERY_STATUSES = [
  "pending",
  "sent",
  "expired",
  "invalid_token",
  "failed",
  "skipped",
] as const satisfies readonly DeliveryStatus[];

/** A text by language: `{ uz: "Yangi xizmat", ru: "Новая услуга" }`. */
export type Texts = Readonly<Record<string, string>>;

/** An announcement as staff write it: hg-notify's `CreateCampaignRequest`, every field said. */
export interface CampaignInput {
  market_code: string;
  audiences: Side[];
  /** Empty: the whole market. An admin names their own areas, one at least. */
  area_ids: string[];
  title: LocalizedText;
  /** In the languages of the title. */
  body: LocalizedText;
  link: string | null;
  expires_at: string | null;
}
